import { OnInit, Input, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-dynamic-column',
  template: '<div class="col-12 text-center">' +
            '<input type="checkbox" readonly [(ngModel)]="this.rowData[\'seleccionado\']"/>' +
            '</div>',
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class RowSelectionCheckboxComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: any;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/row-selection-checkbox.component.ts